import React from 'react';
import { Link } from 'react-router-dom';
import { DEMO_URL } from '../data/links';
export function CtaBand() {
  return <div className="ctaband" data-id="element-37" data-mp="ciu14mvz62ft">
      <h2 style={{
      fontSize: 'clamp(26px,3.6vw,44px)',
      maxWidth: 'none'
    }} data-id="element-38" data-mp="ck54illid86e">Bring your highest standards.</h2>
      <p className="lede" data-id="element-39" data-mp="hji2o2hty1oa">
        Choose a real workflow. We&rsquo;ll show you what the model was told &mdash; and prove it.
      </p>
      <div className="ctas" data-id="element-40" data-mp="rg4lymuicko7">
        <a className="btn g" href={DEMO_URL} target="_blank" rel="noopener" data-id="element-41" data-mp="retiyp8vzgy5">
          Book a demo &rarr;
        </a>
        <Link className="btn o" to="/contact" data-id="element-42" data-mp="vetvu5gc7k33">
          Contact us
        </Link>
      </div>
    </div>;
}